<template>
    <v-row>
        <v-col cols="12">
            <v-form>
                <v-container>
                <v-row v-if="authToken">
                    <v-col cols="12" sm="6" md="4" lg="4">
                    <v-select
                    :items="[2,3,4]"
                    label="How many Continuous Assessment"
                    v-model="rsettings.kinds_of_ca"
                    @change="emitForm"
                    outlined dense
                    required
                    ></v-select>
                    </v-col>

                    <v-col cols="12">
                        <v-row>
                            <v-col cols="12" sm="6" md="4" lg="3">
                            <v-select
                            :items="scoreGroupMax"
                            @change="emitForm" label="1st CA Max Score:"
                            v-model="rsettings.ca1" 
                            dense
                            outlined
                            ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" v-if="rsettings.kinds_of_ca > 1">
                            <v-select
                            :items="scoreGroupMax"
                            @change="emitForm" label="2nd CA Max Score:"
                            v-model="rsettings.ca2" 
                            dense
                            outlined
                            ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" v-if="rsettings.kinds_of_ca > 2">
                            <v-select
                            :items="scoreGroupMax"
                            @change="emitForm" label="3rd CA Max Score:"
                            v-model="rsettings.ca3" 
                            dense
                            outlined
                            ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" v-if="rsettings.kinds_of_ca > 3">
                            <v-select
                            :items="scoreGroupMax"
                            @change="emitForm" label="4th CA Max Score:"
                            v-model="rsettings.ca4" 
                            dense
                            outlined
                            ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3">
                            <v-select
                            :items="scoreGroupMax"
                            @change="emitForm" label="Exam Max Score:"
                            v-model="rsettings.exam" 
                            dense
                            outlined
                            ></v-select>
                            </v-col>
                        </v-row>
                    </v-col>
                    
                    <v-col cols="12">
                        <v-btn x-small text color="info" @click="showMore = !showMore">Show/Hide More Settings</v-btn>                        
                        <v-divider></v-divider>
                    </v-col>
                    
                    <v-col cols="12" v-if="showMore">
                        <!--  -->
                        <v-row>
                        <v-col cols="12">
                            <v-alert
                            dense
                            border="left"
                            color="yellow"
                            >
                            Some of the options marked 1 Token are <strong>PREMIUM SERVICE</strong> that will cost 1 TOKEN each if selected
                            </v-alert>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.motto" @change="emitForm" label="Show School Motto"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.address" @change="emitForm" label="Show School Contact Info"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.watermark" @change="emitForm" label="Show School Logo Watermark"></v-checkbox></v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.regnum" @change="emitForm" label="Show Student Reg. Number"></v-checkbox>
                            </v-col>

                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.age" @change="emitForm" label="Show Student Age"></v-checkbox>
                            </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.photo" @change="emitForm" label="Show Student Photo"></v-checkbox>
                            </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.attendance" @change="emitForm" label="Show Student Attendance"></v-checkbox>
                            </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.gender" @change="emitForm" label="Show Student Gender"></v-checkbox>
                            </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.csize" @change="emitForm" label="Show Class Size"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.sascore" @change="emitForm" label="Show Subject Average Score"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.shlscores" @change="emitForm" label="Show Subject Highest and Lowest Scores"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.sposition" @change="emitForm" label="Show Subject Position"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.sgrading" @change="emitForm" label="Show Subject Grading"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.sremarks" @change="emitForm" label="Show Subject Remarks"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3"><v-checkbox v-model="rsettings.ptss" @change="emitForm" label="Show Possible Total Score for Subjects"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.cummulative" @change="premiumContent" label="Show Three Terms Cummulative Scores (1 Token)" color="red"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.cposition" @change="emitForm" label="Show Student Class Position"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.ntrd" @change="emitForm" label="Show Next Term Resumption Date"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.ktg" @change="emitForm" label="Show Keys to Grading"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.cteacher" @change="emitForm" label="Show Class Teacher Name"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.shremarks" @change="premiumContent" label="Show Remarks (1 Token)" color="red"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.psymotor" @change="premiumContent" label="Show Psycho-motors (1 Token)" color="red"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-checkbox v-model="rsettings.pinfo" @change="emitForm" label="Show Info to Parents"></v-checkbox>
                        </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                </v-container>
            </v-form>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'SettingsForm',
    props:[
        'authToken', 
        'school',
        'terms',
        'classes',
    ],
    data () {
        return {
            rsettings:localStorage.getItem('school') ? JSON.parse(localStorage.getItem('school')).settings : {},
            showMore: false,
            scoreGroupMax: [10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 75, 80, 90, 100],
            tokensUsed: 0
        }
    },
    metaInfo: {
        meta: [
            { name: 'viewport', content: 'width=device-width,initial-scale=1.0' }
        ]
    },
    mounted() {
        // Premium content
        this.premiumContent()
    },
    methods:{
        premiumContent(){
           if (this.rsettings.psymotor == 1 || this.rsettings.shremarks == 1 || this.rsettings.cummulative == 1) {
                    this.tokensUsed = 1;
            }
            if ((this.rsettings.psymotor == 1 && this.rsettings.shremarks == 1) || (this.rsettings.cummulative == 1 && this.rsettings.shremarks == 1) || (this.rsettings.psymotor == 1 && this.rsettings.cummulative == 1)) {
                this.tokensUsed = 2;
            }
            if (this.rsettings.psymotor == 1 && this.rsettings.shremarks == 1 && this.rsettings.cummulative == 1) {
                this.tokensUsed = 3;
            }
            if (this.rsettings.psymotor == 0 && this.rsettings.shremarks == 0 && this.rsettings.cummulative == 0) {
                this.tokensUsed = 0;
            }
            this.$emit('tokens', this.tokensUsed)
            this.emitForm();
        },
        emitForm (){
            this.$emit('settings', [{settings:this.rsettings}])
        },
    }
}
</script>

<style scoped>
</style>